export default "__VITE_ASSET__z_oxH1Rn__"